import { render, staticRenderFns } from "./new_01.vue?vue&type=template&id=1ce83762&scoped=true"
import script from "./new_01.vue?vue&type=script&lang=js"
export * from "./new_01.vue?vue&type=script&lang=js"
import style0 from "./new_01.vue?vue&type=style&index=0&id=1ce83762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce83762",
  null
  
)

export default component.exports